import React, { useState } from "react";
import LeftSideChat from "./chat/LeftSideChat";
import Inbox from "./Inbox/Inbox";
import Informations from "./Information/Informations";
import { classNames } from "../../../../helpers/classNames";

const ChatBox = ({
  selectChatHandler,
  messages,
  chatInfo,
  onSend,
  chatList,
  onMessageScroll = () => {},
  myMessagesDivRef,
  messageLoading,
  onSearch = () => {},
  onChatListLoad = () => {},
  searchValue,
  selectedChat,
  setSelectedChat,
  activeChatId,
}) => {
  return (
    <div className="w-full flex shadow-lg rounded-lg relative overflow-hidden">
      <div
        className={
          "flex flex-col py-6 px-4 overflow-hidden bg-white rounded-l-lg w-full lg:w-96 flex-shrink-0"
        }
      >
        <LeftSideChat
          selectChatHandler={selectChatHandler}
          chatList={chatList}
          onSearch={onSearch}
          searchValue={searchValue}
          setSelectedChat={setSelectedChat}
          activeChatId={activeChatId}
          onChatListLoad={onChatListLoad}
        />
      </div>
      <div
        className={classNames(
          "absolute h-full lg:h-auto lg:relative flex flex-col overflow-hidden chat-box border-theme-5 flex-shrink flex-grow border-l bg-gray-100 rounded-r-lg w-full lg:w-auto left-0 lg:top-auto lg:left-auto transition-all duration-300",
          selectedChat ? "translate-x-0" : "translate-x-full lg:translate-x-0"
        )}
      >
        <Inbox
          onMessageScroll={onMessageScroll}
          messages={messages}
          chatInfo={chatInfo}
          onSend={onSend}
          ref={myMessagesDivRef}
          loading={messageLoading}
          setSelectedChat={setSelectedChat}
        />
      </div>
      {/* <div className="flex flex-col col-span-12 pl-6 pr-6 overflow-hidden info-content xl:col-span-3 xl:pl-0">
        <Informations />
      </div> */}
    </div>
  );
};

export default ChatBox;
